import React from "react";

import Hero from "./Hero";
import CoverageStrip from "./CoverageStrip";
import Customers from "./Customers";
import TiolPartnership from "./TiolPartnership";
import Landscape from "./Landscape";
import Platform from "./Platform";
import LegalInsights from "./LegalInsights";
import AlertsSpotlight from "./AlertsSpotlight";
import Workflow from "./Workflow";
import Impact from "./Impact";
import PracticeAreas from "./PracticeAreas";
import WhoItsFor from "./WhoItsFor";
import Security from "./Security";
import Faq from "./Faq";
import Contact from "./Contact";

// Header and Footer live in your layout (App.jsx) as before.
// If you want to keep your old <Registration /> form instead of <Contact />, just swap them.
const Body = () => (
  <main className="main vd-page">
    <Hero />
    <CoverageStrip />
    {/* <Customers /> */}
    <TiolPartnership />
    <Landscape />
    <Platform />
    <LegalInsights />
    <AlertsSpotlight />
    <Workflow />
    <Impact />
    <PracticeAreas />
    <WhoItsFor />
    <Security />
    <Faq />
    <Contact />
  </main>
);

export default Body;
